import { httpPost } from "@/request/http";

let path = "/charts";

export default {
  getStores(dTO) {
    return httpPost(`${path}/line/stores`, dTO);
  },
  getTerminals(dTO) {
    return httpPost(`${path}/line/terminals`, dTO);
  },
};
